// Everything a promoter shares so brands book an event (ShareKit: booking
// link, Instagram images, QR code), in a pop-up. Opens by itself right after
// publishing (`justPublished`: "your event is live!") and from the share
// button on the My Events cards.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Modal, ModalFoot, ModalHead } from 'components/Modal';
import ShareKit from 'components/ShareKit';

export default function ShareEventModal({ event, justPublished = false, onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal isOpen={Boolean(event)} onClose={onClose} size="md">
      {event && (
        <>
          <ModalHead
            eyebrow={justPublished ? t('share_kit.published_eyebrow') : event.name}
            title={justPublished ? t('share_kit.published_title') : t('share_kit.title')}
            sub={
              justPublished
                ? t('share_kit.published_sub', { event: event.name })
                : t('share_kit.subtitle')
            }
          />
          <div className="px-6 sm:px-9 py-6 overflow-y-auto">
            <ShareKit event={event} />
          </div>
          <ModalFoot className="justify-end">
            {event.slug && (
              <button
                type="button"
                onClick={() => {
                  onClose();
                  navigate(`/event/${event.slug}`);
                }}
                className="px-4 py-2.5 rounded-lg text-sm font-semibold text-gray-800 hover:bg-gray-100"
              >
                {t('share_kit.view_event')}
              </button>
            )}
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2.5 rounded-lg text-sm font-semibold bg-gray-900 text-white hover:bg-black"
            >
              {t('share_kit.done')}
            </button>
          </ModalFoot>
        </>
      )}
    </Modal>
  );
}
